import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import { IeLynxObject } from "../../common/models/eLynxObject";
import { IColumn, ImportTypeEnum } from "../../services/data-file-import-data-service/Models";

export const keys = {
    all: ["data-file-import"],

    configurations: (groupID: number 

    ) => [
        ...keys.all,
        "configurations", {
            groupID
            }
    ],
    configuration: (
        groupID: number,
        configurationID: number | undefined,
        
    ) => [
        ...keys.all,
        "configuration", {
            groupID,
            configurationID,
        }
    ],
    objectMap: (
        groupID: number,
        fileName: string,
        fileHasHeaderRow: boolean,
        identifierColumn: IColumn,
        importObjectType: eLynxObjectTypeEnum    
            
    ) => [
        ...keys.all,
        "object-map", {
            groupID,
            fileName,
            fileHasHeaderRow,
            identifierColumn,
            importObjectType    
        
        }
    ],
    tagTypeMap: (
        groupID: number,
        fileHasHeaderRow: boolean,
        importObjectType: eLynxObjectTypeEnum,
        importType: ImportTypeEnum,
        tagTypeColumns: IColumn[],
        objects: IeLynxObject[] | undefined
    ) => [
        ...keys.all,
        "tag-type-map", {
            groupID,
            fileHasHeaderRow,
            importObjectType,
            importType,
            tagTypeColumns,
            objects
            
        }
    ],
    organizationObjects: (
        groupID: number,
        objectType: eLynxObjectTypeEnum
    ) => [
        ...keys.all,
        "organization-objects", {
            groupID,
            objectType
            
        }
    ],

    // alarmSchemes: (
    //     organizationID: number | undefined,
    //     groupID: number
    //     ) => [
    //         ...keys.all,
    //         "alarmschemes", {
    //             organizationID,
    //             groupID,
    //         }
    //     ],
};

